import React, { useState } from "react";
import * as XLSX from "xlsx";

export default function Bases({ onSelect }) {
  const [bases, setBases] = useState([]);
  const [selected, setSelected] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Variável para armazenar a pesquisa
  const [loading, setLoading] = useState(false); // Estado para controle do carregamento
  const [isSearchFocused, setIsSearchFocused] = useState(false); // Estado para controlar o foco na pesquisa

  // Função para lidar com o upload do arquivo
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true); // Inicia o carregamento
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Seleciona a segunda aba da planilha
        const secondSheet = workbook.Sheets[workbook.SheetNames[1]];

        // Converte os dados da aba em JSON
        const sheetData = XLSX.utils.sheet_to_json(secondSheet, {
          header: 1, // Mantém o formato original para mapear cabeçalhos manualmente
        });

        // Extrai os cabeçalhos e formata os dados
        const headers = sheetData[0]; // Primeira linha da planilha
        const formattedData = [];
        let stopReading = false;

        // Itera pelas linhas da planilha, interrompendo ao encontrar 'TOTAL'
        for (let i = 1; i < sheetData.length; i++) {
          const row = sheetData[i];
          if (row.includes("TOTAL")) {
            stopReading = true; // Encontra o 'TOTAL', então para a leitura
            break;
          }
          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = row[index] || ""; // Adiciona valores ou vazio
          });
          formattedData.push(obj);
        }

        // Ordena as bases alfabeticamente pelo nome da base
        formattedData.sort((a, b) => (a.BASE || "").localeCompare(b.BASE || ""));

        setBases(formattedData);
        setLoading(false); // Finaliza o carregamento
      };

      reader.readAsArrayBuffer(file);
    }
  };

  // Função para lidar com a pesquisa
  const handleSearch = (event) => {
    setSearchQuery(event.target.value); // Atualiza o valor da pesquisa
  };

  const handleSelect = (base) => {
    const updatedSelected = [...selected, base];
    setSelected(updatedSelected);
    onSelect(updatedSelected);

    // Reorganiza as bases: selecionadas no topo, não selecionadas abaixo
    const updatedBases = [
      ...updatedSelected,
      ...bases.filter((b) => !updatedSelected.includes(b)),
    ];

    setBases(updatedBases);
  };

  const handleDeselect = (base) => {
    const updatedSelected = selected.filter((b) => b !== base);
    setSelected(updatedSelected);
    onSelect(updatedSelected);

    // Reorganiza as bases: selecionadas no topo, não selecionadas abaixo
    const updatedBases = [
      ...updatedSelected,
      ...bases.filter((b) => !updatedSelected.includes(b)),
    ];

    setBases(updatedBases);
  };

  // Filtra as bases com base na pesquisa
  const filteredBases = bases.filter((base) =>
    base.BASE.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="w-[300px] h-screen bg-white-whiter shadow-lg border-r overflow-y-auto">
      <div className="sticky top-0 bg-white-whiter p-4 shadow-md">
        {/* Quadrado sólido contendo o botão de inserir arquivo e a barra de pesquisa */}
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          {/* Input para carregar arquivo */}
          <input
            type="file"
            accept=".xlsx"
            onChange={handleFileUpload}
            className="mb-4 w-full p-2 border rounded-lg"
          />
          {/* Barra de pesquisa */}
          <input
            type="text"
            placeholder="Pesquise uma base..."
            value={searchQuery}
            onChange={handleSearch}
            onFocus={() => setIsSearchFocused(true)} // Define o foco na barra de pesquisa
            onBlur={() => setIsSearchFocused(false)} // Remove o foco quando o campo perder o foco
            className={`w-full p-2 border rounded-lg focus:outline-none focus:border-salBlue`} // Altera a borda dependendo do foco
          />
        </div>
      </div>

      {/* Popup de carregamento */}
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center z-30">
          <div className="bg-white-whiter p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-2xl font-bold">Carregando dados...</h2>
            <p className="my-4">Aguarde enquanto as bases estão sendo carregadas.</p>
          </div>
        </div>
      )}

      <div className="p-4">
        {filteredBases.length === 0 ? (
          <p className="text-gray-500 text-center">Nenhuma base encontrada.</p>
        ) : (
          filteredBases.map((base, index) => (
            <div
              key={index}
              className={`p-4 mb-2 rounded-lg border hover:border-salBlue cursor-pointer ${
                selected.includes(base)
                  ? "border-salBlue bg-blue-100"
                  : "border-gray-300 hover:bg-gray-200"
              }`}
              onClick={() =>
                selected.includes(base)
                  ? handleDeselect(base)
                  : handleSelect(base)
              }
            >
              {base.BASE}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
